module.exports = __webpack_public_path__ + "static/cfr-logo-b0c96c1c7a5233a828d28cdc6274c109.png";